import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.components.modal`, {
  'components.modal.close': `Close`,
  'components.modal.close-modal': `Close modal`,
  'components.modal.close-window': `Close Window`,
});
